
import { defineComponent, PropType } from 'vue'
import { TGroup } from '@/types'

export default defineComponent({
  name: 'GroupDetail',
  props: {
    info: {
      type: Object as PropType<TGroup>
    }
  }
})
